module.exports = __webpack_public_path__ + "img/hearthhands.1fe5bc1e.svg";